// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language_container {
  display: flex;
  flex-wrap: wrap;
}

.language_container .form-check {
  flex: 0 0 calc(33.333% - 1rem);
  white-space: nowrap;
}

.radioGrp .form-check {
  margin-right: 10px;
}

@media (max-width: 768px) {
  .language_container .form-check {
    flex: 0 0 50%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .language_container .form-check {
    flex: 0 0 calc(33.333% + 0rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/language/language.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;AACF;;AAEA;EACE,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF;AAMA;EACE;IACE,8BAAA;EAJF;AACF","sourcesContent":[".language_container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.language_container .form-check {\n  flex: 0 0 calc(33.333% - 1rem);\n  white-space: nowrap;\n}\n\n.radioGrp .form-check {\n  margin-right: 10px;\n}\n\n@media (max-width: 768px) {\n  .language_container .form-check {\n    flex: 0 0 50%;\n  }\n\n  // .language_container .form-check-input {\n  //   margin-right: 0.3rem;\n  // }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .language_container .form-check {\n    flex: 0 0 calc(33.333% + 0rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
